import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  TextField,
  Typography,
  Modal,
  Grid,
  RadioGroup,
  Stack,
  Pagination,
  FormControl,
  FormControlLabel,
  Radio,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import React, { Children, useEffect, useRef, useState } from "react";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import Swal from "sweetalert2";
import dayjs from "dayjs";
import { TextFieldSearch } from "../../common/fieldText";
import PoprchModal from "./popSearch";

export default function FormSalary({
  formda,
  setFormda,
  open,
  setOpen,
  existingComponents = [],
}) {
  const [search, setSearchvalue] = useState("");
  const [searchModal, setSearchModal] = useState(false);
  const [errors, setErrors] = useState({
    empId: false,
    componentName: false,
    amount: false,
    percentage: false,
  });
  const [errorMessages, setErrorMessages] = useState({
    empId: "",
    componentName: "",
    amount: "",
    percentage: "",
  });

  const struct = {
    empId: "",
    componentDetails: [],
  };

  const [addCompError, setAddCompError] = useState({
    empId: false,
    componentName: false,
    amount: false,
    percentage: false,
  });

  const compErrorStruct = {
    empId: false,
    componentName: false,
    amount: false,
    percentage: false,
  };

  const [cardValue, setCardValue] = useState(null);
  const [radioType, setRadioType] = useState("amount");

  const componentStruct = {
    componentName: "",
    amount: "",
    percentage: "",
  };

  const [component, setComponent] = useState(componentStruct);

  useEffect(() => {
    if (open == true && formda?.empId) {
      setFormda({ ...formda, empId: formda.empId });
      setSearchvalue(formda?.employeeName);
    }
  }, [open]);

  const validateForm = () => {
    let isValid = true;
    const newErrors = { ...errors };
    const newErrorMessages = { ...errorMessages };

    // Validate employee selection
    if (!formda?.empId) {
      newErrors.empId = true;
      newErrorMessages.empId = "Please select an employee";
      isValid = false;
    } else {
      newErrors.empId = false;
      newErrorMessages.empId = "";
    }

    // Validate component name
    if (!formda?.componentName?.trim()) {
      newErrors.componentName = true;
      newErrorMessages.componentName = "Component name is required";
      isValid = false;
    } else {
      newErrors.componentName = false;
      newErrorMessages.componentName = "";
    }

    // Validate amount
    if (radioType === "amount") {
      if (!formda?.amount || isNaN(formda.amount) || formda.amount <= 0) {
        newErrors.amount = true;
        newErrorMessages.amount = "Please enter a valid positive amount";
        isValid = false;
      } else {
        newErrors.amount = false;
        newErrorMessages.amount = "";
      }
    }

    // Validate percentage (if percentage type is selected)
    if (radioType === "percentage") {
      if (
        !formda?.percentage ||
        isNaN(formda.percentage) ||
        formda.percentage <= 0 ||
        formda.percentage > 100
      ) {
        newErrors.percentage = true;
        newErrorMessages.percentage =
          "Please enter a valid percentage between 1 and 100";
        isValid = false;
      } else {
        newErrors.percentage = false;
        newErrorMessages.percentage = "";
      }
    }

    setErrors(newErrors);
    setErrorMessages(newErrorMessages);
    return isValid;
  };

  const onClose = () => {
    setOpen(false);
    setFormda(null);
    setSearchvalue("");
    setAddCompError(compErrorStruct);
    setErrors(compErrorStruct);
    setErrorMessages({
      empId: "",
      componentName: "",
      amount: "",
      percentage: "",
    });
  };

  const resetFormFields = () => {
    setFormda((prev) => ({
      ...prev,
      componentName: "",
      amount: "",
      percentage: "",
    }));
    setErrors(compErrorStruct);
    setErrorMessages({
      empId: "",
      componentName: "",
      amount: "",
      percentage: "",
    });
  };

  // const handleAddComponent = () => {
  //   if (!validateForm()) {
  //     return;
  //   }

  //   const isDuplicate = formda?.componentDetails?.some(
  //     (comp) =>
  //       comp.componentName.trim().toLowerCase() ===
  //       formda.componentName.trim().toLowerCase()
  //   );

  //   if (isDuplicate) {
  //     Swal.fire({
  //       toast: true,
  //       position: "top-end",
  //       icon: "warning",
  //       title: "This component has already been added.",
  //       showConfirmButton: false,
  //       timer: 3000,
  //       timerProgressBar: true,
  //       customClass: {
  //         popup: "swal2-toast",
  //       },
  //       didOpen: (toast) => {
  //         toast.style.zIndex = 2000; // Ensure it's above the MUI Modal (default 1300)
  //       },
  //     });
  //     return;
  //   }

  //   setFormda({
  //     ...formda,
  //     componentDetails: [
  //       ...(formda.componentDetails ?? []),
  //       {
  //         ...formda,
  //         percentage: formda?.percentage ? formda?.percentage : 0,
  //         amount: formda?.amount ? formda?.amount : 0,
  //       },
  //     ],
  //   });
  //   resetFormFields();
  // };
  const handleAddComponent = () => {
    if (!validateForm()) return;

    // Step 1: Find the employee data from existing components
    const employeeData = existingComponents.find(
      (emp) => emp.empId === formda.empId
    );

    // Step 2: If found, check if the component already exists
    const componentExistsInBackend = employeeData?.componentDetails?.some(
      (comp) =>
        comp.componentName.trim().toLowerCase() ===
        formda.componentName.trim().toLowerCase()
    );

    if (componentExistsInBackend) {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "warning",
        title: "This component already exists for this employee.",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        customClass: {
          popup: "swal2-toast",
        },
        didOpen: (toast) => {
          toast.style.zIndex = 2000;
        },
      });
      return;
    }

    // Step 3: Also check if this component is already added locally
    const isDuplicateInSession = formda?.componentDetails?.some(
      (comp) =>
        comp.componentName.trim().toLowerCase() ===
        formda.componentName.trim().toLowerCase()
    );

    if (isDuplicateInSession) {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "warning",
        title: "This component is already added.",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        customClass: {
          popup: "swal2-toast",
        },
        didOpen: (toast) => {
          toast.style.zIndex = 2000;
        },
      });
      return;
    }

    // Step 4: If all clear, add component locally
    setFormda({
      ...formda,
      componentDetails: [
        ...(formda.componentDetails ?? []),
        {
          ...formda,
          percentage: formda?.percentage || 0,
          amount: formda?.amount || 0,
        },
      ],
    });

    resetFormFields();
  };

  return (
    <Box>
      <Grid container sx={{ position: "relative" }}>
        <Grid item xs={12} sx={{ p: "20px" }}>
          <Grid container spacing={1} sx={{ position: "relative" }}>
            <Grid item xs={12} sm={12}>
              <FormControl fullWidth error={errors.empId}>
                {/* <TextFieldSearch
                  label={"Select Employee"}
                  search={search}
                  notEditable={formda?.id ? true : false}
                  setOpen={setSearchModal}
                  error={errors.empId}
                  helperText={errorMessages.empId}
                /> */}
                <TextField
                  label="Select Employee"
                  value={search}
                  InputLabelProps={{
                    className: "mulish",
                    shrink: !!search,
                    sx: {
                      color: "#545454",
                      fontWeight: 400,
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      paddingX: "7px",
                    },
                  }}
                  size="small"
                  InputProps={{
                    classes: { input: "mulish" },
                    endAdornment: (
                      <SearchIcon
                        onClick={() => {
                          setSearchModal(true);
                        }}
                        sx={{
                          color: (theme) => theme.palette.primary.main,
                          cursor: "pointer",
                          fontSize: { xs: "14px", sm: "14px", md: "15px" },
                        }}
                      />
                    ),
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        border: "1px solid #01008B",
                      },
                      "&:hover fieldset": {
                        border: "1px solid #01008B",
                      },
                      "&.Mui-focused fieldset": {
                        border: "1px solid #01008B",
                      },
                      cursor: "pointer",
                    },
                  }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth error={errors.componentName}>
                <TextField
                  label="Salary Component Name"
                  name="componentName"
                  type="text"
                  size="small"
                  value={formda?.componentName}
                  onChange={(e) => {
                    setFormda({ ...formda, componentName: e.target.value });
                    if (e.target.value.trim()) {
                      setErrors({ ...errors, componentName: false });
                      setErrorMessages({ ...errorMessages, componentName: "" });
                    }
                  }}
                  sx={{
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },

                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        border: "1px solid #01008B",
                      },
                      "&:hover fieldset": {
                        border: "1px solid #01008B",
                      },
                      "&.Mui-focused fieldset": {
                        border: "1px solid #01008B",
                      },
                      cursor: "pointer",
                    },
                  }}
                  required
                  error={errors.componentName}
                  helperText={errorMessages.componentName}
                  InputLabelProps={{
                    className: "mulish",
                    sx: {
                      color: "#545454",
                      fontWeight: 400,
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      paddingX: "7px",
                    },
                  }}
                  InputProps={{ classes: { input: "mulish" } }}
                />
              </FormControl>
            </Grid>

            {true && (
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth error={errors.amount}>
                  <TextField
                    label="Amount"
                    name="amount"
                    size="small"
                    value={formda?.amount}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (!isNaN(value) && value >= 0) {
                        setFormda({
                          ...formda,
                          amount: Number(value),
                        });
                        setErrors({ ...errors, amount: false });
                        setErrorMessages({ ...errorMessages, amount: "" });
                      }
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          border: "1px solid #01008B",
                        },
                        "&:hover fieldset": {
                          border: "1px solid #01008B",
                        },
                        "&.Mui-focused fieldset": {
                          border: "1px solid #01008B",
                        },
                        cursor: "pointer",
                      },
                    }}
                    required
                    error={errors.amount}
                    helperText={errorMessages.amount}
                    InputLabelProps={{
                      className: "mulish",
                      sx: {
                        color: "#545454",
                        fontWeight: 400,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        paddingX: "7px",
                      },
                    }}
                    InputProps={{ classes: { input: "mulish" } }}
                  />
                </FormControl>
              </Grid>
            )}

            <Grid item xs={12} sx={{ display: "flex", justifyContent: "end" }}>
              <Button
                variant="contained"
                sx={{
                  width: "120px",
                  height: "35px",
                  marginRight: "10px",
                   fontSize: { xs: "12px", sm: "13px", md: "15px" },
                }}
                onClick={() => resetFormFields()}
              >
                Clear
              </Button>
              <Button
                variant="contained"
                sx={{
                  width: "120px",
                  height: "35px",
                   fontSize: { xs: "12px", sm: "13px", md: "15px" },
                }}
                onClick={handleAddComponent}
              >
                Add
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <PoprchModal
        cardValue={cardValue}
        setCardValue={(data) => {
          setSearchvalue(data?.name);
          setCardValue(data);
          setFormda({ ...formda, empId: data.id });
          setErrors({ ...errors, empId: false });
          setErrorMessages({ ...errorMessages, empId: "" });
        }}
        callback={() => {}}
        searchModal={searchModal}
        setSearchModal={setSearchModal}
        config={{
          salary: true,
        }}
      />
    </Box>
  );
}
